import Vue from 'vue';

export {default as profileDB} from './components/profile'

export default {

  getUsers(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/users`).then(
      resp => {
        /* eslint-disable */
        let users = resp.body;
        users.forEach((user, i) => {
          users[i].status = user.status.split(',');
        });
        cb(users);
        /* eslint-enable */
      },
    );
  },
  getMedia(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/media`).then(resp => cb(resp.body));
  },
  /**
   *
   * @param cb {function} callback
   */
  getContentImageSlider(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/content/image_slider`).then(resp => cb(resp.body));
  },
  /**
   *
   * @param cb {function} callback
   */
  getContentNews(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/content/news`).then(resp => cb(resp.body));
  },
  /**
   *
   * @param cb {function} callback
   */
  getContentComments(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/content/news_comments`).then(resp => cb(resp.body));
  },
  putNewsItem(item) {
    // console.log(item);
    Vue.http.put(`${Vue.helper.apiUrl()}/content/news/${item.id}`, item);
  },
  putNewsComment(comment) {
    Vue.http.put(`${Vue.helper.apiUrl()}/content/news_comments/${comment.id}`, comment);
  },
  putUser(user) {
    Vue.http.put(`${Vue.helper.apiUrl()}/users/${user.id}`, user);
  },
  getTrainingPages(cb) {
    Vue.http.get(`${Vue.helper.apiUrl()}/content/training`).then(resp => cb(resp.body));
  },

  getTimeTables(cb) {
    Vue.http.get(Vue.helper.apiUrl() + '/content/timetable').then(({body: timetables}) => {
      Vue.http.get(Vue.helper.apiUrl() + `/content/timeObj`).then(({body: timeObj}) => {cb(timetables,timeObj)})
    })
  }
};
